import { z } from 'zod'

export const schema = z.object({
  deals: z.array(
    z.object({
      id: z.string(),
      rentUnitId: z.string(),
      title: z.string(),
      description: z.string(),

      whatIncludes: z.string(),

      total: z.object({
        amount: z.number().int(),
        currency: z.enum(['EUR']),
      }),

      totalOld: z.object({
        amount: z.number().int(),
        currency: z.enum(['EUR']),
      }),

      percentage: z.number(),

      dateIn: z.string(),
      dateOut: z.string(),

      nights: z.number().int(),
      people: z.number().int(),

      pricePersonNight: z.object({
        amount: z.number().int(),
        currency: z.enum(['EUR']),
      }),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  id: z.string(),
  limit: z.number().int(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
